if (!customElements.get('pdp-v2-features')) {
  customElements.define(
    'pdp-v2-features',
    class PdpV2Features extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('.pdp-v2-feature--expandable')];
        this.items.forEach((item) => {
          const toggle = item.querySelector('[data-pdp-v2-feature-toggle]');
          if (!toggle) return;
          toggle.addEventListener('click', () => this.toggleItem(item, toggle));
        });
      }

      toggleItem(item, toggle) {
        const panel = item.querySelector('[data-pdp-v2-feature-panel]');
        if (!panel) return;

        const willOpen = !item.classList.contains('is-open');

        // Accordion: close others
        this.items.forEach((other) => {
          if (other === item) return;
          this.setOpen(other, other.querySelector('[data-pdp-v2-feature-toggle]'), false);
        });

        this.setOpen(item, toggle, willOpen);
      }

      setOpen(item, toggle, open) {
        const panel = item.querySelector('[data-pdp-v2-feature-panel]');
        if (!item || !panel) return;

        item.classList.toggle('is-open', open);
        if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');

        if (open) {
          panel.hidden = false;
          // Force reflow then expand for CSS transition
          panel.style.maxHeight = '0px';
          requestAnimationFrame(() => {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          });
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          requestAnimationFrame(() => {
            panel.style.maxHeight = '0px';
          });
          const onEnd = (event) => {
            if (event.propertyName !== 'max-height') return;
            panel.removeEventListener('transitionend', onEnd);
            if (!item.classList.contains('is-open')) panel.hidden = true;
          };
          panel.addEventListener('transitionend', onEnd);
        }
      }
    }
  );
}
